import {defineComponent} from "vue";
import OptionBaseControl from "@/library/templates/default/controls/OptionBaseControl";

export default defineComponent({
  name: "CheckBoxList",
  extends: OptionBaseControl,
});
